import React from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { FeatherIcon } from "component/shared/feather-icon";
import * as Icons from "react-feather";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { RootState } from "redux/store";
import { deleteIntegration } from "redux/slice/integrations";
import { Integration } from "model/integration";
import { styles } from "./style";
import { AppCard } from "component/shared/app-card";

const mapStateToProps = (state: RootState) => {
	return {
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
	deleteIntegration,
}, dispatch);

interface Props extends
	ReturnType<typeof mapStateToProps>,
	ReturnType<typeof mapDispatchToProps>,
	WithStyles<typeof styles>
{
	integration: Integration;
	deletable: boolean;
	content: React.ReactNode;
	actions?: React.ReactNode;
}

class Component extends React.Component<Props> {

	public render() {
		const { classes = {}, integration, content, actions, deletable, deleteIntegration } = this.props;
		return (
			<AppCard className={classes.card}>
				<Mui.CardHeader
					className={classes.header}
					avatar={integration.integrationType.iconUrl ? (
						<img
							className={classes.icon}
							src={integration.integrationType.iconUrl}
							alt={`Icon for ${integration.label}`}
						/>
					) : (
						<FeatherIcon>
							<Icons.Tool />
						</FeatherIcon>
					)}
					title={integration.label}
					titleTypographyProps={{
						variant: "h4",
						style: { fontSize: 18, fontWeight: 700, color: "#1C1B1F" },
					}}
				/>
				<Mui.CardContent className={classes.content}>
					{content}
				</Mui.CardContent>
				<Mui.CardActions className={classes.cardActions}>
					{actions}
					{/* Trash sits bottom-right per the Q2 2026 card design (was header top-right) */}
					{deletable && (
						<Mui.IconButton
							size="small"
							onClick={() => {
								if (window.confirm("Delete this integration?")) {
									deleteIntegration({integration});
								}
							}}
						>
							<FeatherIcon>
								<Icons.Trash />
							</FeatherIcon>
						</Mui.IconButton>
					)}
				</Mui.CardActions>
			</AppCard>
		);
	}

}

export const Card = withStyles(connect(
	mapStateToProps,
	mapDispatchToProps,
)(Component), styles);